import { render, staticRenderFns } from "./App.vue?vue&type=template&id=b69aa744&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=b69aa744&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b69aa744",
  null
  
)

export default component.exports